import { processesRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { AssociateWorkflowToProcess } from '../types';

export const useAssociateWorkflowToProcess = () =>
  useMutation<ApiResponse<unknown>, unknown, AssociateWorkflowToProcess>(
    (workflowProcess) =>
      processesRepo.associateWorkflowToProcess(workflowProcess),
  );
